import React from 'react'

function Spinner() {
  return (
    <span className="loading loading-spinner loading-lg my-16"></span>
  )
}

export default Spinner